var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 0A11.614 11.614 0 0 0 0 11.625 11.614 11.614 0 0 0 11.625 23.25 11.614 11.614 0 0 0 23.25 11.625 11.614 11.614 0 0 0 11.625 0Zm5.813 15.798-1.64 1.64-4.173-4.174-4.173 4.174-1.64-1.64 4.174-4.173-4.174-4.173 1.64-1.64 4.173 4.174 4.173-4.174 1.64 1.64-4.174 4.173 4.174 4.173Z",
    fill: "#323232"
  })));
};
export default SvgCancel;